import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { WA_WINDOW } from '@ng-web-apis/common';
import { ChameleonCompany, ChameleonWindow } from './domain/chameleon-window.model';

@Injectable({
  providedIn: 'root',
})
export class ChameleonService {
  private readonly router = inject(Router);
  private readonly window = inject<ChameleonWindow>(WA_WINDOW);

  private navigationHandlerRegistered = false;

  public isReady(): boolean {
    // The install snippet first stubs `chmln` as a bare queueing function; the real SDK replaces
    // it with an object whose methods we actually need. Check for a method to know it's real.
    return typeof this.window.chmln?.identify === 'function';
  }

  public identify(userId: string, attrs?: Record<string, unknown>, company?: ChameleonCompany): void {
    const chmln = this.window.chmln;
    if (!this.isReady() || !chmln) {
      this.notLoadedError('Identify User');
      return;
    }

    const payload = company ? { ...attrs, company } : attrs;

    chmln.rmaIdentity = payload;
    chmln.identify(userId, payload);
  }

  public clear(): void {
    const chmln = this.window.chmln;
    if (!this.isReady() || !chmln) {
      this.notLoadedError('Clear');
      return;
    }
    chmln.clear();
  }

  public registerNavigationHandler(): void {
    const chmln = this.window.chmln;
    if (this.navigationHandlerRegistered || !this.isReady() || !chmln) {
      return;
    }
    this.navigationHandlerRegistered = true;
    chmln.on('app:navigate', (...args: unknown[]) => {
      const url = args[0];
      if (typeof url === 'string') {
        this.router.navigateByUrl(url).catch((err) => console.error('Chameleon navigation failed', err));
      }
    });
  }

  private notLoadedError(action: string): void {
    console.error(`${action} not sent as Chameleon is not ready`);
  }
}
